import React from "react"
import Cabecalho from "../Cabecalho"
import { NotificacaoPushComponent } from "./components/NotificacaoPushComponent"

export function NotificacaoPush() {
    return (
        <>
            <Cabecalho pagina="Notificação Push" />
            <NotificacaoPushComponent />
        </>
    )
}
